import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { BuilderContextProvidersSiteConfig, ContextProviderRegistry } from './types'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

export const BuilderContextProvidersRegistry = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: BuilderContextProvidersSiteConfig): ContextProviderRegistry => {
		const registry: { [contextType: string]: any } = {}
		return {
			registerContextProvider: (contextType: string, contextProviderModule: any) => {
				registry[contextType] = contextProviderModule
			},
			getContextProvider: (contextType: string) => {
				return registry[contextType]
			},
			getUseContextHook: (contextType: string) => {
				const hookAccessor = siteFeatureConfig.contextProviders[contextType]!.contextSpecifier!.hook!
				return registry[contextType][hookAccessor]
			},
		}
	}
)
